import { Component, OnInit } from '@angular/core';
import { slideInOut } from '../../utils/animations/slides.animation';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import SlotService from '../../cart-process/slot.service';

@Component({
  selector: 'contract-disclaimers',
  templateUrl: './contract-disclaimers.component.html',
  animations: [slideInOut]
})
export class ContractDisclaimersComponent implements OnInit {
  public headerText: string;
  public disclaimerContent: string;
  public disclaimerTitle: string;
  public contractDisclaimerContent1: string;
  public contractDisclaimerContent2: string;
  public isDisclaimerListVisible = false;
  public isRetentionWithSim = false;
  public isDisclaimerVisible = false;

  constructor(
    public commonInfo: CommonInfoService,
    private slotService: SlotService,
    private notificationProvider: NotificationProviderService,
  ) {
  }

  ngOnInit(): void {
    this.prepareDisclaimerText();

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (commonInfo) {
        this.update();
      }
    });
  }

  private update(): void {
    if (this.commonInfo.isRetentionOffer && !this.slotService.hasAtLeastOneDeviceInCart()) {
      this.headerText = 'Poniższe dokumenty są do wglądu. Nie musisz ich drukować.';
    }
    else if (this.commonInfo.isOtherSalesOffer) {
      this.headerText = 'Poniższe dokumenty są do wglądu.';
    }
    else {
      this.headerText = 'Poniższe dokumenty są do wglądu. Nie musisz ich drukować. Komplet dokumentów dostaniesz od nas przy podpisywaniu umowy.';
    }
  }

  private prepareDisclaimerText(): void {
    const isOnlySim = !(this.slotService.hasAtLeastOneDeviceInSlots() || this.slotService.hasAccessory());
    const isRetentionWithSim = this.commonInfo.isRetentionOffer && isOnlySim;
    const isRetentionWithoutSim = this.commonInfo.isRetentionOffer && !isOnlySim;
    const isNotOtherSalesAndNotRetentionWithSim = !(this.commonInfo.isOtherSalesOffer || this.commonInfo.isRetentionOffer) && isOnlySim;
    const isNotOtherSalesAndNotRetentionWithoutSim = !(this.commonInfo.isOtherSalesOffer || this.commonInfo.isRetentionOffer) && !isOnlySim;
    const isOtherSales = this.commonInfo.isOtherSalesOffer;

    this.isRetentionWithSim = isRetentionWithSim;

    if (isRetentionWithSim) {
      this.disclaimerTitle = 'documents.isRetentionWithSim.disclaimerTitle';
      this.disclaimerContent = 'documents.isRetentionWithSim.disclaimerContent';
      this.contractDisclaimerContent1 = 'documents.isRetentionWithSim.contractDisclaimerContent1';
      this.contractDisclaimerContent2 = 'documents.isRetentionWithSim.contractDisclaimerContent2';
    }
    else if (isRetentionWithoutSim) {
      this.disclaimerTitle = 'documents.isRetentionWithoutSim.disclaimerTitle';
      this.disclaimerContent = 'documents.isRetentionWithoutSim.disclaimerContent';
    }
    else if (isNotOtherSalesAndNotRetentionWithSim) {
      this.disclaimerTitle = 'documents.isNotOtherSalesAndNotRetentionWithSim.disclaimerTitle';
      this.disclaimerContent = 'documents.isNotOtherSalesAndNotRetentionWithSim.disclaimerContent';

    }
    else if (isNotOtherSalesAndNotRetentionWithoutSim) {
      this.disclaimerTitle = 'documents.isNotOtherSalesAndNotRetentionWithoutSim.disclaimerTitle';
      this.disclaimerContent = 'documents.isNotOtherSalesAndNotRetentionWithoutSim.disclaimerContent';
    }
    else if (isOtherSales) {
      this.disclaimerTitle = 'documents.isOtherSales.disclaimerTitle';
    }
  }
}
